import { lazy } from 'react';

const routeConfig = [
  {
    path: '/',
    component: lazy(() => import('./Home'))
  },
  {
    path: '/404',
    component: lazy(() => import('./404'))
  },
  {
    path: '/login',
    component: lazy(() => import('./Login'))
  },
  {
    // 产品详情
    path: '/prodDetail',
    component: lazy(() => import('./ProdDetail'))
  },
  {
    // 协议
    path: '/protocol',
    component: lazy(() => import('./Protocol'))
  },
  {
    // 订单确认
    needAuth: true,
    path: '/orderConfirm',
    component: lazy(() => import('./OrderConfirm'))
  },
  {
    // 订单列表
    needAuth: true,
    path: '/orderList',
    component: lazy(() => import('./OrderList'))
  },
  {
    // 订单详情
    needAuth: true,
    path: '/orderDetail',
    component: lazy(() => import('./OrderDetail'))
  },
  {
    // 发票信息
    needAuth: true,
    path: '/invoiceInformation',
    component: lazy(() => import('./InvoiceInformation'))
  },
  {
    // 订单详情页发票信息
    needAuth: true,
    path: '/orderDetail/invoiceInformation',
    component: lazy(() => import('./OrderDetail/InvoiceInformation'))
  },
  {
    // 退款申请
    needAuth: true,
    path: '/orderRefund',
    component: lazy(() => import('./OrderRefund'))
  },
  {
    // 个人中心
    path: '/user/userCenter',
    component: lazy(() => import('./User/UserCenter'))
  },
  {
    // 出行人管理
    needAuth: true,
    path: '/user/travelerList',
    component: lazy(() => import('./User/TravelerList'))
  },
  {
    // 新增/编辑出行人
    needAuth: true,
    path: '/user/travelerEdit',
    component: lazy(() => import('./User/TravelerEdit'))
  },
  {
    // 收货地址管理
    needAuth: true,
    path: '/user/addressList',
    component: lazy(() => import('./User/AddressList'))
  },
  {
    // 新增/编辑收货地址
    needAuth: true,
    path: '/user/addressEdit',
    component: lazy(() => import('./User/AddressEdit'))
  },
  {
    // 签证-办签进度
    needAuth: true,
    path: '/visa/visaProgress',
    component: lazy(() => import('./Visa/VisaProgress'))
  },
  {
    // 签证-材料清单
    needAuth: true,
    path: '/visa/visaMaterialList',
    component: lazy(() => import('./Visa/VisaMaterialList'))
  },
  {
    // 签证-上传预审
    needAuth: true,
    path: '/visa/visaUploadFiles',
    component: lazy(() => import('./Visa/VisaUploadFiles'))
  },
  {
    // 专题页
    path: '/subject',
    component: lazy(() => import('./Subject'))
  },
  {
    // 三级专题页
    path: '/threeSubject',
    component: lazy(() => import('./ThreeSubject'))
  },
  {
    // 星玩家
    path: '/user/recommendStarPlayer',
    component: lazy(() => import('./User/RecommendStarPlayer'))
  },
  {
    // 中旅总社上海
    path: '/user/recommendTravelSh',
    component: lazy(() => import('./User/RecommendTravelSh'))
  },
  {
    // 福利官
    path: '/user/recommendWelfareOfficer',
    component: lazy(() => import('./User/RecommendWelfareOfficer'))
  },
  {
    // 关于我们
    path: '/user/recommendAboutUs',
    component: lazy(() => import('./User/RecommendAboutUs'))
  },
  {
    // 反馈
    needAuth: true,
    path: '/user/feedback',
    component: lazy(() => import('./User/Feedback'))
  },
  {
    // 目的地
    path: '/destination',
    component: lazy(() => import('./Destination'))
  },
  {
    // 目的地介绍
    path: '/destinationIntroduce',
    component: lazy(() => import('./DestinationIntroduce'))
  },
  {
    // 目的地城市
    path: '/destinationCity',
    component: lazy(() => import('./DestinationCity'))
  },
  {
    // 目的地搜索
    path: '/destinationSearch',
    component: lazy(() => import('./DestinationSearch'))
  },
  {
    // 搜索商品结果
    path: '/searchProd',
    component: lazy(() => import('./SearchProd'))
  },
  {
    // 个人信息设置
    needAuth: true,
    path: '/user/userInfo',
    component: lazy(() => import('./User/UserInfo'))
  },
  {
    // 优惠券列表
    needAuth: true,
    path: '/coupon/couponList',
    component: lazy(() => import('./Coupon/CouponList'))
  },
  {
    // 优惠券适用商品列表
    needAuth: true,
    path: '/coupon/couponProdList',
    component: lazy(() => import('./Coupon/CouponProdList'))
  },
  {
    // 收藏列表
    needAuth: true,
    path: '/user/collectList',
    component: lazy(() => import('./User/CollectList'))
  },
  {
    path: '/signUp/login',
    component: lazy(() => import('./SignUp/SignLogin'))
  },
  {
    needSignAuth: true,
    path: '/signUp/collect',
    component: lazy(() => import('./SignUp/SignCollect'))
  },
  {
    needSignAuth: true,
    path: '/signUp/result',
    component: lazy(() => import('./SignUp/SignResult'))
  },
  {
    path: '/qrpage',
    component: lazy(() => import('./Qrpage'))
  },
  {
    path: '/preview',
    component: lazy(() => import('./Preview'))
  },
  {
    path: '/rule',
    component: lazy(() => import('./Rule'))
  },
  {
    needSignAuth: true,
    path: '/pet/petHome',
    component: lazy(() => import('./Pet/PetHome'))
  },
  {
    path: '/pet/petProduct',
    component: lazy(() => import('./Pet/PetProduct'))
  },
  {
    path: '/pet/PetGoods',
    component: lazy(() => import('./Pet/PetGoods'))
  },
  {
    path: '/pet/PetInfo',
    component: lazy(() => import('./Pet/PetInfo'))
  },
  {
    path: '/pet/PetEdit',
    component: lazy(() => import('./Pet/PetEdit'))
  },
  {
    path: '/pet/PetOrder',
    component: lazy(() => import('./Pet/PetOrder'))
  },
  {
    // 商家端首页
    path: '/retail',
    component: lazy(() => import('./Retail/Home'))
  },
  {
    // 商家端产品详情
    path: '/retail/prodDetail',
    component: lazy(() => import('./Retail/ProdDetail'))
  },
  {
    // 企微挂载应用页面
    path: '/exam',
    component: lazy(() => import('./Exam'))
  },
  {
    // 企微登录页面
    path: '/exam/login',
    component: lazy(() => import('./Exam/Login'))
  },
  {
    // 企微列表页面
    needExamAuth: true,
    path: '/exam/list',
    component: lazy(() => import('./Exam/List'))
  },
  {
    // 企微挂载应用页面-调休
    path: '/adjustLeave',
    component: lazy(() => import('./AdjustLeave'))
  },
  {
    // 企微挂载应用页面-调休
    path: '/adjustLeave/login',
    component: lazy(() => import('./AdjustLeave/Login'))
  },
  {
    // 企微挂载应用页面-调休首页总览
    path: '/adjustLeave/home',
    component: lazy(() => import('./AdjustLeave/Home'))
  },
  {
    // 企微挂载应用页面-调休无权限页
    path: '/adjustLeave/noPermission',
    component: lazy(() => import('./AdjustLeave/NoPermission'))
  },
  {
    // 企微挂载应用页面-手动调整调休页
    path: '/adjustLeave/vacationEdit',
    component: lazy(() => import('./AdjustLeave/VacationEdit'))
  },
  {
    // 企微挂载应用页面-个人考勤页
    path: '/adjustLeave/attendance',
    component: lazy(() => import('./AdjustLeave/Attendance'))
  },
  {
    // 企微挂载应用页面-邀请列表
    path: '/adjustLeave/faceRegister',
    component: lazy(() => import('./AdjustLeave/FaceRegister'))
  },
  {
    // 企微挂载应用页面-录制页面
    path: '/adjustLeave/inviteeEdit',
    component: lazy(() => import('./AdjustLeave/FaceRegister/InviteeEdit'))
  },
  {
    // 考试首页
    needExamAuth: true,
    path: '/exam/home',
    component: lazy(() => import('./Exam/Home'))
  },
  {
    // 考试结果页
    needExamAuth: true,
    path: '/exam/result',
    component: lazy(() => import('./Exam/Result'))
  },
  {
    // 考试答题页
    needExamAuth: true,
    path: '/exam/examCollect',
    component: lazy(() => import('./Exam/ExamCollect'))
  },
  {
    // 考试结束中转页
    needExamAuth: true,
    path: '/exam/examCollect/resultMain',
    component: lazy(() => import('./Exam/ExamCollect/ResultMain'))
  },
  {
    // AI问答
    path: '/maiAi',
    component: lazy(() => import('./MaiAi'))
  },
  {
    path: '/main/ai',
    component: lazy(() => import('./MainAi/Home'))
  },
  {
    path: '/main/general',
    component: lazy(() => import('./MainAi/General'))
  },
  {
    path: '/main/planTrip',
    component: lazy(() => import('./MainAi/PlanTrip'))
  },
  {
    path: '/main/dialogue',
    component: lazy(() => import('./MainAi/MainDialogue'))
  },
  {
    path: '/main/share',
    component: lazy(() => import('./MainAi/Share'))
  },
  {
    // 企业ip
    path: '/trademark',
    component: lazy(() => import('./Trademark'))
  },
];

export default routeConfig;
